import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import session from "../session";

/** Where to land after a completed sign-in: the page the user was bounced
 *  from (RequireAuth stashes it in router state; okta-react's LoginCallback
 *  reads the same state), query string preserved. Falls back to the default
 *  landing page for a fresh sign-in with no origin. */
export const landingPath = (state: unknown, fallback = "/home"): string => {
  const from = (state as { from?: { pathname?: string; search?: string } } | undefined | null)?.from;
  return from?.pathname ? `${from.pathname}${from.search ?? ""}` : fallback;
};

export const OktaLogin = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();

  useEffect(() => {
    if (authState?.isAuthenticated === false && !authState?.isPending) {
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth]);

  if (authState?.isPending) {
    return <div>Loading...</div>;
  }

  if (authState?.isAuthenticated) {
    session.start();
    // Return the user to the page they were bounced from (RequireAuth and
    // the Okta callback both stash it in location.state); /home is only the
    // fallback for a fresh sign-in with no origin.
    return <Navigate to={landingPath(location.state)} replace />;
  }

  return <div>Loading...</div>;
};
